import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
import { Box } from "@mui/system";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    keywordname: "best betting",
    matchType: "Exact",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
  },
  {
    id: 2,
    keywordname: "betting sites uk",
    matchType: "Exact",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
  },
  {
    id: 3,
    keywordname: "sports betting",
    matchType: "Broad",
    AdgroupName: "UK - Football Betting | Tier 2 | Exact*",
    campaignName: "Sport | UK | EN | Tier 5 Offers | TCPA | FTD",
  },
  {
    id: 4,
    keywordname: "best betting sites",
    matchType: "Exact",
    AdgroupName: "UK - Betting Sites | Tier 3 |",
    campaignName: "Sport | IE | EN | Comparison 1 | TCPA | FTD",
  },
];

const SaveChangesST = ({ open, rowData, onClose }: any) => {
  // --- Define columns ---
  const columns: GridColDef[] = [
    {
      field: "keywordname",
      headerName: "Keyword Name",
      flex: 1,
      minWidth: 160,
    },
    {
      field: "matchType",
      headerName: "Match Type",
      flex: 0.6,
      minWidth: 110,
    },
    {
      field: "AdgroupName",
      headerName: "Adgroup Name",
      flex: 1,
      minWidth: 200,
    },
    {
      field: "campaignName",
      headerName: "Campaign Name",
      flex: 1,
      minWidth: 220,
    },
  ];

  if (!rowData) return null;

  return (
    <Dialog open={open} onClose={onClose} maxWidth="lg" fullWidth>
      <DialogTitle>Other Keywords</DialogTitle>
      <DialogContent>
        <Box>
          <Typography>Set as Exclusive</Typography>
          <Box sx={{ width: "100%", display: "grid", mt: 1 }}>
            <DataGridPro
              sx={{
                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                  { outline: "none" },
                "& .MuiDataGrid-cellEmpty": {
                  width: "auto",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },

                // row selection only once
                "& .MuiDataGrid-row.Mui-selected": {
                  backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                  "&:hover": {
                    backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                  },
                },

                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft":
                  {
                    backgroundColor: "#f0def3 !important",
                  },
                "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                  {
                    backgroundColor: "#e6d6e9ff !important",
                  },

                // pinned RIGHT
                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#f0def3 !important",
                  },
                "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#e6d6e9ff !important",
                  },
                // make pinned cells transparent → let row bg show through
                "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#ffffff",
                  },

                // remove extra blue tint on single cell select
                "& .MuiDataGrid-cell.Mui-selected": {
                  backgroundColor: "inherit !important",
                },

                "& .MuiCheckbox-root": {
                  color: "#9c27b0 !important",
                },
                "& .MuiCheckbox-root.Mui-checked": {
                  color: "#9c27b0",
                },
                border: "none",
              }}
              density="compact"
              hideFooter
              pagination={false}
              rows={rows}
              columns={columns}
              disableColumnMenu
              disableColumnFilter
              disableColumnReorder
              sortingOrder={["asc", "desc"]}
              isCellEditable={() => false}
              disableRowSelectionOnClick
            />
          </Box>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography>Set as Allowed</Typography>
          <Box sx={{ width: "100%", display: "grid", mt: 1 }}>
            <DataGridPro
              sx={{
                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                  { outline: "none" },
                "& .MuiDataGrid-cellEmpty": {
                  width: "auto",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },

                // row selection only once
                "& .MuiDataGrid-row.Mui-selected": {
                  backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                  "&:hover": {
                    backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                  },
                },

                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft":
                  {
                    backgroundColor: "#f0def3 !important",
                  },
                "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                  {
                    backgroundColor: "#e6d6e9ff !important",
                  },

                // pinned RIGHT
                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#f0def3 !important",
                  },
                "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#e6d6e9ff !important",
                  },
                // make pinned cells transparent → let row bg show through
                "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#ffffff",
                  },

                // remove extra blue tint on single cell select
                "& .MuiDataGrid-cell.Mui-selected": {
                  backgroundColor: "inherit !important",
                },

                "& .MuiCheckbox-root": {
                  color: "#9c27b0 !important",
                },
                "& .MuiCheckbox-root.Mui-checked": {
                  color: "#9c27b0",
                },
                border: "none",
              }}
              density="compact"
              hideFooter
              pagination={false}
              rows={rows}
              columns={columns}
              disableColumnMenu
              disableColumnFilter
              disableColumnReorder
              sortingOrder={["asc", "desc"]}
              isCellEditable={() => false}
              disableRowSelectionOnClick
            />
          </Box>
        </Box>
        <Box sx={{ mt: 2 }}>
          <Typography>Set as Negative</Typography>
          <Box sx={{ width: "100%", display: "grid", mt: 1 }}>
            <DataGridPro
              sx={{
                "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                  outline: "none",
                },
                "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                  { outline: "none" },
                "& .MuiDataGrid-cellEmpty": {
                  width: "auto",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                },

                // row selection only once
                "& .MuiDataGrid-row.Mui-selected": {
                  backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                  "&:hover": {
                    backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                  },
                },

                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft":
                  {
                    backgroundColor: "#f0def3 !important",
                  },
                "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                  {
                    backgroundColor: "#e6d6e9ff !important",
                  },

                // pinned RIGHT
                "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#f0def3 !important",
                  },
                "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#e6d6e9ff !important",
                  },
                // make pinned cells transparent → let row bg show through
                "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                  {
                    backgroundColor: "#ffffff",
                  },

                // remove extra blue tint on single cell select
                "& .MuiDataGrid-cell.Mui-selected": {
                  backgroundColor: "inherit !important",
                },

                "& .MuiCheckbox-root": {
                  color: "#9c27b0 !important",
                },
                "& .MuiCheckbox-root.Mui-checked": {
                  color: "#9c27b0",
                },
                border: "none",
              }}
              density="compact"
              hideFooter
              pagination={false}
              rows={rows}
              columns={columns}
              disableColumnMenu
              disableColumnFilter
              disableColumnReorder
              sortingOrder={["asc", "desc"]}
              isCellEditable={() => false}
              disableRowSelectionOnClick
            />
          </Box>
        </Box>
      </DialogContent>
      <DialogActions sx={{ padding: "16px 20px 16px" }}>
        <Button onClick={onClose} color="secondary" variant="outlined">
          Cancel
        </Button>
        <Button variant="contained" onClick={onClose} color="secondary">
          Confirm
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SaveChangesST;
